export default "__VITE_ASSET__C1t35iBl__"